import ValueFormatter from '@fxxl/fxxl_value_formatter';

export default class FxxlInputFormatController {
    constructor(container = document) {
        this.elements = container.querySelectorAll('input[data-format].fxxl-text-input__text');
        this.init();
    }

    init() {
        this.elements.forEach(el => {
            if (!el.fxxl_input_format_controller_initialized) {
                const formatType = el.dataset.format;
                if (formatType) {
                    this.applyFormattedValue(el, formatType);
                    if (formatType === 'date_de') {
                        el.addEventListener('keydown', e => {
                            e.target.fxxl_input_format_controller_delete_input = ['Backspace', 'Delete'].includes(e.key);
                        });
                        el.addEventListener('input', e => {
                            if (
                                e.inputType?.startsWith('delete')
                                || e.target.fxxl_input_format_controller_delete_input === true
                            ) {
                                e.target.fxxl_input_format_controller_delete_input = false;
                                return;
                            }

                            e.target.fxxl_input_format_controller_delete_input = false;
                            this.applyFormattedValue(e.target, formatType, true);
                        });
                    }
                    el.addEventListener('focusout', e => {
                        this.applyFormattedValue(e.target, formatType);
                    });
                }
                el.fxxl_input_format_controller_initialized = true;
            }
        });
    }

    applyFormattedValue(element, formatType, keepCaret = false, formatterOptions = {}) {
        if (!element.value) {
            return;
        }

        const originalValueLength = element.value.length;
        let selectionStart = null;
        let selectionEnd = null;
        let digitCountStart = 0;
        let digitCountEnd = 0;

        if (keepCaret) {
            selectionStart = element.selectionStart;
            selectionEnd = element.selectionEnd;
            digitCountStart = this.getDigitCountBeforePosition(element.value, selectionStart);
            digitCountEnd = this.getDigitCountBeforePosition(element.value, selectionEnd);
        }

        const value = ValueFormatter.format(element.value, formatType, formatterOptions);
        if (value !== null && value !== 'NaN') {
            if (value === element.value) {
                return;
            }

            element.value = value;

            if (
                keepCaret
                && selectionStart !== null
                && selectionEnd !== null
                && typeof element.setSelectionRange === 'function'
            ) {
                let formattedSelectionStart = this.getPositionAfterDigitCount(value, digitCountStart);
                let formattedSelectionEnd = this.getPositionAfterDigitCount(value, digitCountEnd);

                if (selectionStart === originalValueLength) {
                    formattedSelectionStart = value.length;
                }

                if (selectionEnd === originalValueLength) {
                    formattedSelectionEnd = value.length;
                }

                element.setSelectionRange(formattedSelectionStart, formattedSelectionEnd);
            }
        }
    }

    getDigitCountBeforePosition(value, position) {
        if (position === null) {
            return 0;
        }

        return value.slice(0, position).replace(/\D/g, '').length;
    }

    getPositionAfterDigitCount(value, digitCount) {
        let currentDigitCount = 0;

        if (digitCount === 0) {
            return 0;
        }

        for (let i = 0; i < value.length; i++) {
            if (/\d/.test(value.charAt(i))) {
                currentDigitCount++;
            }

            if (currentDigitCount === digitCount) {
                let position = i + 1;
                while (position < value.length && /\D/.test(value.charAt(position))) {
                    position++;
                }

                return position;
            }
        }

        return value.length;
    }
}
